function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-109.3,326.2c-7.5,0-14.7-0.8-21.8-2.5c-6.7-1.7-13.4-3.8-20.1-6.7c5.9,4.2,10.9,8.8,15.9,14.2c4.6,5,8.8,10.9,12.6,17.2 c3.4,6.3,6.3,12.6,8.8,19.7c2.5,6.7,3.8,14.2,4.6,21.4c0.8-7.1,2.1-14.2,4.6-21.4c2.1-7.1,5.4-13.8,8.8-19.7 c3.8-6.3,8-11.7,12.6-17.2c5-5.4,10.1-10.1,15.9-14.2c-6.3,2.9-13,5-20.1,6.7C-94.6,325-101.7,325.8-109.3,326.2z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-108.7,413.8c-7.5,0-14.7-0.8-21.8-2.5c-6.7-1.7-13.4-3.8-20.1-6.7c5.9,4.2,10.9,8.8,15.9,14.2c4.6,5,8.8,10.9,12.6,17.2 c3.4,6.3,6.3,12.6,8.8,19.7c2.5,6.7,3.8,14.2,4.6,21.4c0.8-7.1,2.1-14.2,4.6-21.4c2.1-7.1,5.4-13.8,8.8-19.7 c3.8-6.3,8-11.7,12.6-17.2c5-5.4,10.1-10.1,15.9-14.2c-6.3,2.9-13,5-20.1,6.7C-94.1,412.5-101.2,413.3-108.7,413.8z"
});

var SvgSwrpgFailureFailure = function SvgSwrpgFailureFailure(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgFailureFailure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-failure-failure.081cbd2e.svg";
export { ForwardRef as ReactComponent };